import React from 'react';
import { get, isEmpty, times, fromPairs, map, size, isEqual, head } from 'lodash';
import classnames from 'classnames';

import { Form } from 'modules/form';
import { getLabel } from 'utils/getLabel';
import { button as Button } from 'modules/button';
import { infoPill as InfoPill } from 'ui/views/generic/infoPill';

// import PropTypes from 'prop-types';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { Icon } from 'modules/icon-bank';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { callCategoriesAndReasons as CallCategoriesAndReasons } from 'ui/views/widgets/callCategoriesAndReasons';
 *
 * // render
 * <CallCategoriesAndReasons propName='propValue'/>
 */
const callCategoriesAndReasonsSuccess = ( props ) => {

    const { title = {}, primaryActions = [], visibility= {}, sections = {} } = get( props, 'componentData', null );

    const { activeSection = null } = props;

    const activeSectionName = get( sections, `${activeSection}`, {} );

    const _formFields = get( activeSectionName, 'fields', [] );

    const _actions = get( activeSectionName, 'actions', [] );

    const _fieldActions = get( activeSectionName, 'fieldActions', [] );
    
    return (
        <div className='ui-call-categories-and-reasons'>
            
            {/* header */ }
            <_CardHeader
                title= { title }
                primaryActions= { primaryActions }
                visibility= { visibility }
                onSectionChange = { props.onSectionChange }
                activeSection = { activeSection }
            />

            {/* Error info */ }

            { props.errorInfo && (
                <InfoPill
                    value= { props.errorInfo }
                />
            ) }


            {/* form */ }
            <_FormView
                formFields = { _formFields }
                actions = { _actions }
                fieldActions = { _fieldActions }
                onChangeCallBack = { props.onChangeCallBack }
                values = { props.values }
                isFormValid = { props.isFormValid }
                handleSubmit = { props.handleSubmit }
                handleCancel = { props.handleCancel }
                handleReasonDeletion = { props.handleReasonDeletion }
                handleReasonAddition = { props.handleReasonAddition }
                errorInfo= { props.errorInfo }
                keepFieldsDisabled= { props.keepFieldsDisabled }
                newReasonsList = { props.newReasonsList }
            />


        </div>
    );
};

// set display name
callCategoriesAndReasonsSuccess.displayName = 'callCategoriesAndReasonsSuccess';

// set default props
callCategoriesAndReasonsSuccess.defaultProps = {};

// prop types
callCategoriesAndReasonsSuccess.propTypes = {};

/********************************************** */

const _CardHeader = ( props ) => {

    const { title, primaryActions, visibility, activeSection } = props;

    return (
        <div className='ui-call-categories-and-reasons__header'>

        {/* title */}
        <div className='ui-call-categories-and-reasons__header__title'>

            <Icon id= 'calling'/>

            <span>{ getLabel( title ) }</span>
        </div>

        {/* actions */}
        <div className='ui-call-categories-and-reasons__header__actions'>

            {
                !isEmpty( primaryActions ) && primaryActions.map( ( action ) => {

                    const isVisible = get( visibility, `${action.visibility}`, false );

                    return (
                        isVisible ? ( <Button
                            type='button'
                            size='medium'
                            label={ action.title }
                            outline={ false }
                            disabled= { activeSection === get( action, 'name', null ) ? true : false }
                            onClick={ () => { props.onSectionChange( get( action, 'name', null ) ); } }
                        /> ): null
                    );
                } )
            }
        </div>

    </div>
    );
};

/********************************************** */

const _FormView = ( props ) => {

    const { fieldActions } = props;

    return (
        <Form
        fields={ fromPairs( map( props.formFields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
        values={ props.values } // default values
        isValid={ false }
        mode='form'
        key={ size( props.formFields ) }

        onChangeCallBack={ props.onChangeCallBack }
        updatFieldsOnChange={ true }
        updatFieldValuesOnChange={ true }
        onSubmit={ ( payload ) => { props.handleSubmit( payload ); } }
    >
        { ( { fields, values, /*isValid,*/ errors, onChange, onSumbit } = {} ) => {

            return (
                <form
                    onSubmit={ onSumbit }
                    className='ui-call-categories-and-reasons__body__form'
                >
                    { /* fields */ }
                    { map( fields, ( field ) => {

                        // if( get( field, 'config.hide' ) ) {
                        //     return null;
                        // }

                        let fieldClassName = classnames( 'ui-call-categories-and-reasons__body__form__field', `ui-call-categories-and-reasons__body__form__${field.name}` );

                        let disabled = false;

                        if( 'reasons' === field.name || 'reasonName' === field.name ) {
                            
                            disabled = props.keepFieldsDisabled;
                        }

                        if ( get( field, 'actionRef', null ) ) {

                            fieldClassName = classnames( 'ui-call-categories-and-reasons__body__form__field ui-call-categories-and-reasons__body__form__field-with-actions', `ui-call-categories-and-reasons__body__form__${field.name}` );

                            const actionObj = head( fieldActions );

                            return (
                                <div className={ fieldClassName } >
                                    <div className = 'ui-call-categories-and-reasons__body__form__field-with-action__container'>
                                        <field.view
                                            className={ 'ui-call-categories-and-reasons__body__form__field-with-action' }
                                            key={ field.name }
                                            name={ field.name }
                                            required={ field.required }
                                            placeholder={ field.placeholder }
                                            label={ field.title }
                                            onChange={ onChange }
                                            value={ values[ field.name ] }
                                            error={ errors[ field.name ] }
                                            options={ field.options } // get( props.formData.options, field.options ) }
                                            allowFilter={ 'reasons' === field.name }
                                            config={ field.config }
                                            subFields={ props.subFields }
                                            optionsList={ props.options }
                                            disabled= { disabled }
                                        />

                                        {
                                            !isEmpty( props.newReasonsList ) && (
                                                <div className= 'ui-call-categories-and-reasons__body__form__field-with-action__tags'>

                                                    { props.newReasonsList.map( ( reason ) => {
                                                        return (
                                                            <div className= 'ui-call-categories-and-reasons__body__form__field-with-action__tags__item' onClick = { () => { props.handleReasonDeletion( reason ); } } >
                                                                <span>{ reason }</span>
                                                                <span className= 'ui-call-categories-and-reasons__body__form__field-with-action__tags__item__cancel'>x</span>
                                                            </div>
                                                        );
                                                    } ) }

                                                </div>
                                            )
                                        }

                                    </div>
    
                                    { !isEmpty( actionObj ) && (
    
                                        <Button
                                            type='button'
                                            size='medium'
                                            label={ actionObj.title }
                                            outline={ true }
                                            onClick={ () => { props.handleReasonAddition( { ...actionObj } ); } }
                                            disabled= { isEmpty( get( props, 'values.reasonName', '' ) ) || disabled }
                                        />
                                    ) }
                                </div>
                            );
                        } else {
                            return (
                                <field.view
                                    className={ fieldClassName }
                                    key={ field.name }
                                    name={ field.name }
                                    required={ field.required }
                                    placeholder={ field.placeholder }
                                    label={ field.title }
                                    onChange={ onChange }
                                    value={ values[ field.name ] }
                                    error={ errors[ field.name ] }
                                    options={ field.options } // get( props.formData.options, field.options ) }
                                    allowFilter={ 'reasons' === field.name }
                                    config={ field.config }
                                    subFields={ props.subFields }
                                    optionsList={ props.options }
                                    disabled= { disabled }
                                />
                            );
                        }


                    } ) }

                    {/* button actions */}
                    <div className='ui-call-categories-and-reasons__body__form__actions'>
                        { map( props.actions, action => {
                            return (
                                <Button
                                    key={ action.name }
                                    id= { action.name }
                                    type= { 'cancel' !== action.name ? 'submit' : 'button' }
                                    disabled={ 'cancel' !== action.name && !props.isFormValid ? true : false }
                                    { ...action }
                                    outline={ 'cancel' === action.name ? true: false }
                                    size='large'
                                    className='ui-call-categories-and-reasons__body__form__actions__action'
                                    onClick = { isEqual( 'cancel', action.name ) ?  () => {
                                        props.handleCancel();
                                    } : null }
                                />
                            );
                        } ) }
                    </div>
                </form>
            );
        } }
    </Form>
    );
};

/********************************************** */

const callCategoriesAndReasonsPreloader = () => {
	return (
		<div className='ui-call-categories-and-reasons-preloader'>
			<div className='ui-call-categories-and-reasons-preloader__header'>
				<div className='ui-call-categories-and-reasons-preloader__header__title'></div>
                <div className='ui-call-categories-and-reasons-preloader__header__buttons'>
                    <div className='ui-call-categories-and-reasons-preloader__header__buttons__btn'/>
                    <div className='ui-call-categories-and-reasons-preloader__header__buttons__btn'/>
                </div>
			</div>
			<div className='ui-call-categories-and-reasons-preloader__body'>
				{ times( 3 ).map( ( index ) => {
					return (
						<div
							key={ index }
							className='ui-call-categories-and-reasons-preloader__body__form-field'
						>
						</div>
					);
				} ) }
			</div>
            <div className='ui-call-categories-and-reasons-preloader__navigation'>
                <div className='ui-call-categories-and-reasons-preloader__navigation__nav'></div>
                <div className='ui-call-categories-and-reasons-preloader__navigation__nav'></div>
            </div>
		</div>
	);
 };

// set display name
callCategoriesAndReasonsPreloader.displayName = 'callCategoriesAndReasonsPreloader';

// set default props
callCategoriesAndReasonsPreloader.defaultProps = {};

// prop types
callCategoriesAndReasonsPreloader.propTypes = {};


/********************************************** */

export const callCategoriesAndReasons = withNetworkState(
	callCategoriesAndReasonsPreloader,
	callCategoriesAndReasonsSuccess
);
